import React from 'react'
import { v4 } from 'uuid'
import { ItemProd } from '../components/itemprod'

const futures = [
  {
    id: v4(),
    title: 'Без ФН',
    desc: '29.000,00',
  },
  {
    id: v4(),
    title: 'С фн на 15 месяцев',
    desc: '41.600,00',
  },
  {
    id: v4(),
    title: 'С фн на 36 месяцев',
    desc: '47.100,00',
  },
]

const data = {
  img: './images/st73-02-1.png',
  title: 'Эвотор 7.3 Смарт-терминал',
  desc: 'Подойдёт тем, кому важна возможность без розетки работать на кассе — ювелирным магазинам, салонам красоты, спортклубам и бутикам.',
}

export const St73 = () => {
  return (
    <>
      <ItemProd data={data} futures={futures} />
    </>
  )
}
